<template>
  <div class="footer">
    <div class="wid1003">上海医健卫生事务服务中心&nbsp;&nbsp;版权所有 <a style="color:#fff;" href="http://www.miitbeian.gov.cn/publish/query/indexFirst.action" target="_blank">沪ICP备15055130号</a></div>
  </div>
</template>

<script>
  export default {
    name: 'footerNav',
    data() {
      return {
        curDate: new Date().getFullYear()
      };
    }
  }
</script>
<style>
  .footer {
    height: 20px;
    background: #002d74;
    line-height: 20px;
    text-align: center;
    color: #fff;
    padding: 20px 10px 20px 10px;
    margin-top: 10px;
  }
.wid1003 {
    width: 1003px;
    margin: 0 auto;
  }
  @media screen and (max-width: 1000px)
  {
    .footer { width:1200px; }
  }
  .icon-footer{font-size: 18px;}
</style>



// WEBPACK FOOTER //
// src/components/common/FooterView.vue